export const USER_NOT_FOUND = 'UserNotFoundException' as const;
export const LIMIT_EXCEEDED = 'LimitExceededException' as const;
export const NOT_AUTHORISED = 'NotAuthorizedException' as const;
export const COGNITO_ERRORS = {
  [USER_NOT_FOUND]:
    'Account not found.  If you believe this is an error, please click the onboarding link emailed to you at account creation.',
  [LIMIT_EXCEEDED]: `Attempt limit exceeded, please try after some time.`,
  [NOT_AUTHORISED]: 'Old password do not match.'
} as const;
